import { gatewayClient, createService } from './connectors/httpClient';
import FigmaFile from 'packages/pages/designCreateModal/pages/figma/FigmaFile';

const httpClient = gatewayClient('/figma');

const figmaService = createService(httpClient, (client) => ({
    getConnectionStatus() {
        return client.get<
            | { connected: false; message: string }
            | { connected: true; figmaUserId: string; email: string; created: string }
        >('/auth/connection-status');
    },

    getLoginUrl(location: string) {
        return client.get<{ url: string }>(`/auth/login-url?location=${encodeURIComponent(location)}`);
    },

    revokeAccess() {
        return client.delete('/auth/revoke-access');
    },

    getFile(fileKey: string) {
        return client.get<typeof FigmaFile | { status: string }>(`/files/${fileKey}`, {}, {}, false);
    },
}));

export default figmaService;
